import { render, staticRenderFns } from "./LegalDocs.vue?vue&type=template&id=6945ffba"
import script from "./LegalDocs.vue?vue&type=script&lang=js"
export * from "./LegalDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports